var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconLeftLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5973 0.397498C11.1342 0.927495 11.1342 1.78679 10.5973 2.31679L3.31954 9.5L10.5973 16.6832C11.1342 17.2132 11.1342 18.0725 10.5973 18.6025C10.0603 19.1325 9.1897 19.1325 8.65273 18.6025L0.402728 10.4596C-0.134244 9.92965 -0.134244 9.07035 0.402728 8.54036L8.65273 0.397498C9.1897 -0.132499 10.0603 -0.132499 10.5973 0.397498Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconLeftLight);
export default __webpack_public_path__ + "static/media/close-icon-left-light.8cdc226ef590261b82a9bf2f11f097b7.svg";
export { ForwardRef as ReactComponent };